import { create } from 'zustand'
import { createSelectors } from '~/shared/lib/zustand-utils'
import { pickRandom } from '../lib/messages'

const AUTO_DISMISS_MS = 5000

interface ReminderStore {
  isOpen: boolean
  message: string | null
  show: () => void
  hide: () => void
}

// Timeout handle is kept at module scope (not in store state) — it's not UI state
// and doesn't need to trigger re-renders.
let dismissTimeout: ReturnType<typeof setTimeout> | null = null

function clearDismissTimeout() {
  if (dismissTimeout !== null) {
    clearTimeout(dismissTimeout)
    dismissTimeout = null
  }
}

const reminderStore = createSelectors(
  create<ReminderStore>((set, get) => ({
    isOpen: false,
    message: null,
    show: () => {
      clearDismissTimeout()
      set({ isOpen: true, message: pickRandom() })
      dismissTimeout = setTimeout(() => {
        get().hide()
      }, AUTO_DISMISS_MS)
    },
    hide: () => {
      clearDismissTimeout()
      set({ isOpen: false, message: null })
    },
  })),
)

export const useReminderSelectors = () => {
  const isOpen = reminderStore.use.isOpen()
  const message = reminderStore.use.message()
  return { isOpen, message }
}

// Non-reactive action accessors — safe to call from outside React.
export const showReminder = () => reminderStore.getState().show()
export const hideReminder = () => reminderStore.getState().hide()
